import { action, reload, revalidate } from "@solidjs/router";
import { _patchCurrentCart } from "../roma-api/cart";
import { revalidateOnSession } from "../session";
import { getSession, setSession } from "../session";
import { retrieveCart } from "./useCart";

export const updateCurrentCartAction = action(async (id: string) => {
  "use server";

  const response = await _patchCurrentCart(id);
  // console.log("response from _patchCurrentCart >> ", response);

  // TODO - throw an error here, or in _patchCurrentCart ? if thrown there, will an errorBoundary in component catch?

  // check higher up the chain - await elsewhere?
  await setSession({ cart_id: id });

  // await revalidate(getSession.key);
  // await revalidate([retrieveCart.keyFor(id)]);
  // const session = await getSession();
  // console.log('session cart_id after setting witin updateCurrentCartAction >>> ', session?.cart_id)

  // return reload({ revalidate: [getSession.key, retrieveCart.keyFor(id)] });

  // ! PREVIOUS
  // ? this is all a mess ...there was some wierd behaviour and out of order revalidations happning.
  // ? If altering, test behaviour on:
    // 1 - Cart panel, switching carts (normal and while on checkout page viewing cart)
    // 2 - Checkout page
    // 3 - Sign-in

  // await revalidate([retrieveCart.keyFor(id)]);

  // await revalidate([retrieveCart.key, retrieveCart.keyFor(id)]); // putting this here does not cause a loop, placing it in array in reload() fn causes loop...

  // return reload({
  //   revalidate: [getSession.key],
  // });

  // ! END PREVIOUS

  return reload({
    revalidate: [getSession.key, retrieveCart.keyFor(id)],
  });

  // await revalidate(getSession.key); //! endless loop
  // return reload({ revalidate: revalidateOnSession }); //! endless loop
});

// NOV 27 BEFORE MESSING AROUND..THIS IS BUGGY ON CHECKOUT PAGE:
// await revalidate([retrieveCart.key, retrieveCart.keyFor("current")]); // putting this here does not cause a loop, placing it in array in reload() fn causes loop...

// return reload({
//   revalidate: [getSession.key],
// });

// -------------
